import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  & > .title-container {
    align-items: center;
    border-bottom: 1px dashed #1D1D1D;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 0;

    & > div {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      gap: 16px;

      & > p {
        color: #040405;
        font-size: 1rem;
        font-weight: 700;
        line-height: 1.25rem;
      }

      & > .icon {
        height: 24px;
        transition: transform 0.5s ease-in-out;
        width: 24px;

        &.open {
          transform: rotate(180deg);
        }
      }
    }
  }

  & > .content {
    max-height: 0;
    overflow: hidden;
    padding-top: 8px;
    position: relative;
    transition: max-height 0.3s ease-in-out, padding-bottom 0.3s ease-in-out;

    &.open {
      max-height: 1000px;
    }

    p,
    li,
    a {
      color: #1D1D1D;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5rem;
    }

    ul {
      padding-left: 1.5em;
    }

    a {
      text-decoration: underline;
    }
  }
`
